// src/features/landing/presentation/components/MainCategoriesSection.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

export function MainCategoriesSection() {
    const navigate = useNavigate();

    const categories = [
        {
            id: 1,
            kicker: "BRAND STORY",
            title: "라이징브로커즈 소개",
            description: [
                "라이징브로커즈는 보험업계 전문 헤드헌팅 플랫폼으로, GA 매니저·총무·스태프의 체계적인 발굴부터 검증된 매칭까지 전문화된 솔루션을 제공합니다. 15년 이상의 보험업계 노하우를 바탕으로 보험사와 GA, 전문인력 모두가 win-win 하는 생태계를 구축합니다.",
                "우리의 미션은 명확합니다. 투명한 프로세스와 데이터 기반 매칭으로 '중개'의 가치를 재정의하고, 보험업계 인재 채용의 새로운 기준을 만들어갑니다. 회사 철학, 핵심 가치, 그리고 차별화된 강점을 확인하세요.",
            ],
            buttonText: "라이징 브로커즈 소개 더 보기",
            path: "/about",
            visualText: {
                line1: "보험설계사의 개인적 니즈를 종합적으로 AI 분석하여,",
                highlight: "가장 적합한 GA에 매칭하는",
                line2: "중개 솔루션 제공",
            },
            bgColor: "#f5f1ed",
            accentColor: "#c4956f",
            visualBg: "linear-gradient(135deg, #f5ebe0 0%, #ede0d4 100%)",
        },
        {
            id: 2,
            kicker: "OUR SERVICE",
            title: "서비스 소개",
            description: [
                "GA 전문 인력 채용의 모든 단계를 한 곳에서 해결하세요. ① 인바운드/아웃바운드 채널을 통한 후보자 발굴 → ② 역량·경력·성향 기반 정량·정성 평가 → ③ 보험사/GA별 조직문화·상품특성 고려한 최적 매칭까지, 3단계 체계적 프로세스로 채용 성공률을 극대화합니다.",
                "또한 적기 채용 어려움, 높은 소개비 부담, 한정적 인재Pool, 역량 검증 부재 등 기존 GA 채용시장의 5가지 핵심 문제점을 혁신적으로 해결합니다. 구체적인 솔루션과 차별화 포인트를 상세히 확인하세요.",
            ],
            buttonText: "서비스 자세히 보기",
            path: "/service",
            visualText: {
                line1: "인바운드/아웃바운드 채널을 통한",
                highlight: "체계적인 GA 전문 인력 매칭",
                line2: "서비스 제공",
            },
            bgColor: "#f7fafc",
            accentColor: "#2c5282",
            visualBg: "linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%)",
        },
        {
            id: 3,
            kicker: "PREMIUM JOBS",
            title: "프리미엄 채용관",
            description: [
                "전국 주요 보험사·GA의 검증된 채용공고를 실시간으로 확인하세요. FC(재무설계사), GA 매니저, GA 총무, GA 스태프, TMR 등 포지션별·지역별·경력별 맞춤 검색이 가능하며, 정착지원금·DB 제공·3개월 보장제 등 구체적인 처우 조건까지 투명하게 공개됩니다.",
                "단순 공고 나열이 아닌, 각 회사의 조직문화·성장 가능성·복리후생을 종합 분석한 프리미엄 정보를 제공합니다. 지금 나에게 딱 맞는 기회를 찾아보세요.",
            ],
            buttonText: "채용 정보 보기",
            path: "/premium",
            visualText: {
                line1: "검증된 GA 전문 인력",
                highlight: "프리미엄 채용 정보",
                line2: "실시간 업데이트",
            },
            bgColor: "#f5f1ed",
            accentColor: "#c4956f",
            visualBg: "linear-gradient(135deg, #f5ebe0 0%, #ede0d4 100%)",
        },
        {
            id: 4,
            kicker: "CONTACT US",
            title: "제휴 문의",
            description: [
                "보험사·GA를 위한 인력 채용 솔루션, 전문인력을 위한 커리어 등록 및 매칭, 전략적 제휴 제안까지 다양한 형태의 파트너십을 운영합니다. 채용 효율 극대화, 정확한 인력 매칭, 현장 부담 완화 등 3가지 핵심 가치를 제공하며, 유연한 정산체계로 리스크를 최소화합니다.",
                "블로그에서 보험업계 인사이트를 확인하거나, 인스타그램으로 빠른 소식을 받아보세요. 제휴 문의는 온라인 폼, 이메일, 전화 등 편한 방법으로 연락주시면 1영업일 내 답변드립니다.",
            ],
            buttonText: "제휴 문의하기",
            path: "/contact",
            visualText: {
                line1: "보험업계의 새로운 표준,",
                highlight: "지금 파트너십을 시작하세요",
                line2: "함께 성장하는 파트너",
            },
            bgColor: "#f7fafc",
            accentColor: "#2c5282",
            visualBg: "linear-gradient(135deg, #edf2f7 0%, #e2e8f0 100%)",
        },
    ];

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <section className="main-categories-section">
            {categories.map((category, index) => (
                <div
                    key={category.id}
                    className="category-container"
                    style={{ background: category.bgColor }}
                >
                    <div className="category-content">
                        <div className="text-side">
                            <p
                                className="category-kicker"
                                style={{ color: category.accentColor }}
                            >
                                {category.kicker}
                            </p>
                            <h2 className="category-title">{category.title}</h2>

                            <div className="category-description">
                                {category.description.map((paragraph, idx) => (
                                    <p key={idx} className="description-paragraph">
                                        {paragraph}
                                    </p>
                                ))}
                            </div>

                            <button
                                onClick={() => handleNavigation(category.path)}
                                className="category-button"
                                style={{ background: category.accentColor }}
                            >
                                {category.buttonText}
                            </button>
                        </div>

                        <div className="visual-side">
                            <div
                                className="visual-container"
                                style={{ background: category.visualBg }}
                            >
                                <div className="visual-illustration">
                                    {category.id === 1 && (
                                        <div className="brand-visual">
                                            <img
                                                src="/images/slide_1.png"
                                                alt="라이징브로커즈 소개"
                                                className="brand-image"
                                            />
                                        </div>
                                    )}

                                    {category.id === 2 && (
                                        <div className="service-visual">
                                            <div className="process-flow">
                                                <div className="process-step step-1">
                                                    <div className="step-number">1</div>
                                                    <div className="step-name">발굴</div>
                                                </div>
                                                <div className="flow-arrow">→</div>
                                                <div className="process-step step-2">
                                                    <div className="step-number">2</div>
                                                    <div className="step-name">검증</div>
                                                </div>
                                                <div className="flow-arrow">→</div>
                                                <div className="process-step step-3">
                                                    <div className="step-number">3</div>
                                                    <div className="step-name">매칭</div>
                                                </div>
                                            </div>
                                            <div className="service-badges">
                                                <div className="badge-item">체계적 프로세스</div>
                                                <div className="badge-item">역량 검증 시스템</div>
                                                <div className="badge-item">3개월 보장제</div>
                                            </div>
                                        </div>
                                    )}

                                    {category.id === 3 && (
                                        <div className="jobs-visual">
                                            <div className="job-cards-preview">
                                                <div className="preview-card card-1">
                                                    <div className="card-header-mini">
                                                        <div className="company-badge">한화생명</div>
                                                        <div className="status-badge open">모집중</div>
                                                    </div>
                                                    <div className="card-title-mini">GA 매니저</div>
                                                    <div className="card-location">서울</div>
                                                </div>
                                                <div className="preview-card card-2">
                                                    <div className="card-header-mini">
                                                        <div className="company-badge">삼성생명</div>
                                                        <div className="status-badge open">모집중</div>
                                                    </div>
                                                    <div className="card-title-mini">GA 총무</div>
                                                    <div className="card-location">경기</div>
                                                </div>
                                                <div className="preview-card card-3">
                                                    <div className="card-header-mini">
                                                        <div className="company-badge">교보생명</div>
                                                        <div className="status-badge open">모집중</div>
                                                    </div>
                                                    <div className="card-title-mini">FC</div>
                                                    <div className="card-location">부산</div>
                                                </div>
                                            </div>
                                            <div className="jobs-stats">
                                                <div className="stat-pill">
                                                    <span>50+ 채용공고</span>
                                                </div>
                                                <div className="stat-pill">
                                                    <span>실시간 업데이트</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {category.id === 4 && (
                                        <div className="contact-visual">
                                            <div className="contact-simple-list">
                                                <a href="https://blog.naver.com/rising_brokers/224072104964" target="_blank" rel="noopener noreferrer" className="contact-link">
                                                    <div className="contact-simple-item">
                                                        <img src="/images/logo/blog.png" alt="블로그" className="contact-icon" />
                                                        <span className="contact-label">블로그</span>
                                                        <span className="contact-value">rising_brokers</span>
                                                    </div>
                                                </a>
                                                <a href="https://www.instagram.com/risingbrokers_official?igsh=ajB5emx4aDg4cXBi" target="_blank" rel="noopener noreferrer" className="contact-link">
                                                    <div className="contact-simple-item">
                                                        <img src="/images/logo/insta.jpeg" alt="인스타그램" className="contact-icon"/>
                                                        <span className="contact-label">인스타그램</span>
                                                        <span className="contact-value">@risingbrokers_official</span>
                                                    </div>
                                                </a>
                                                <a href="http://pf.kakao.com/_Tdzxen" target="_blank" rel="noopener noreferrer" className="contact-link">
                                                    <div className="contact-simple-item">
                                                        <img src="/images/logo/kakao.png" alt="카카오톡" className="contact-icon"/>
                                                        <span className="contact-label">카카오톡</span>
                                                        <span className="contact-value">라이징브로커즈</span>
                                                    </div>
                                                </a>
                                                <a href="tel:02-858-2014" className="contact-link">
                                                    <div className="contact-simple-item">
                                                        <span className="contact-icon">📞</span>
                                                        <span className="contact-label">본사 연락처</span>
                                                        <span className="contact-value">02-858-2014</span>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            <style jsx>{`
                .main-categories-section {
                    width: 100%;
                }

                .category-container {
                    width: 100%;
                    padding: 100px 60px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 600px;
                }

                .category-content {
                    max-width: 1400px;
                    width: 100%;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 80px;
                    align-items: center;
                }

                .text-side {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .category-kicker {
                    font-size: 0.95rem;
                    font-weight: 600;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    margin: 0;
                }

                .category-title {
                    font-size: 3rem;
                    font-weight: 800;
                    color: #1a1a1a;
                    margin: 0;
                    line-height: 1.3;
                }

                .category-description {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .description-paragraph {
                    font-size: 1.1rem;
                    color: #4a4a4a;
                    line-height: 1.8;
                    margin: 0;
                    font-weight: 400;
                }

                .category-button {
                    align-self: center;
                    border: none;
                    border-radius: 50px;
                    padding: 18px 40px;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: white;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
                    margin-top: 12px;
                }

                .category-button:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
                }

                .category-button:active {
                    transform: translateY(-1px);
                }

                .visual-side {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .visual-container {
                    width: 100%;
                    border-radius: 30px;
                    padding: 50px 40px;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                    min-height: 450px;
                }

                .visual-text-box {
                    background: white;
                    border-radius: 20px;
                    padding: 30px 35px;
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
                }

                .visual-line {
                    font-size: 1.05rem;
                    color: #2c3e50;
                    margin: 0;
                    line-height: 1.7;
                }

                .visual-highlight {
                    font-size: 1.15rem;
                    font-weight: 700;
                    color: #f16102;
                    margin: 8px 0;
                    line-height: 1.7;
                }

                .visual-illustration {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex: 1;
                    padding: 20px;
                }

                /* Brand Visual (Category 1) */
                .brand-visual {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .brand-image {
                    width: 100%;
                    height: auto;
                    object-fit: contain;
                    border-radius: 16px;
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                }

                /* Service Visual (Category 2) */
                .service-visual {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 25px;
                }

                .process-flow {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: rgba(255, 255, 255, 0.6);
                    border-radius: 16px;
                    padding: 25px 20px;
                }

                .process-step {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                }

                .step-number {
                    width: 40px;
                    height: 40px;
                    background: #2c5282;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 800;
                    font-size: 1.2rem;
                    box-shadow: 0 4px 12px rgba(44, 82, 130, 0.25);
                }

                .step-icon {
                    font-size: 2rem;
                }

                .step-name {
                    font-size: 0.95rem;
                    font-weight: 700;
                    color: #2c3e50;
                }

                .flow-arrow {
                    font-size: 1.5rem;
                    color: #2c5282;
                    font-weight: 700;
                    margin: 0 10px;
                }

                .service-badges {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                    justify-content: center;
                }

                .badge-item {
                    background: white;
                    border: 2px solid #2c5282;
                    border-radius: 20px;
                    padding: 10px 20px;
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #2c5282;
                    white-space: nowrap;
                }

                /* Jobs Visual (Category 3) */
                .jobs-visual {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }

                .job-cards-preview {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 12px;
                }

                .preview-card {
                    background: white;
                    border-radius: 12px;
                    padding: 16px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    transition: transform 0.3s ease;
                }

                .preview-card:hover {
                    transform: translateY(-4px);
                }

                .card-header-mini {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 8px;
                }

                .company-badge {
                    font-size: 0.75rem;
                    font-weight: 700;
                    color: #c4956f;
                    background: rgba(196, 149, 111, 0.15);
                    padding: 4px 10px;
                    border-radius: 6px;
                }

                .status-badge {
                    font-size: 0.7rem;
                    font-weight: 600;
                    padding: 3px 8px;
                    border-radius: 4px;
                }

                .status-badge.open {
                    background: #d3f9d8;
                    color: #2b8a3e;
                }

                .card-title-mini {
                    font-size: 0.95rem;
                    font-weight: 700;
                    color: #2c3e50;
                }

                .card-location {
                    font-size: 0.8rem;
                    color: #666;
                }

                .jobs-stats {
                    display: flex;
                    gap: 12px;
                    justify-content: center;
                }

                .stat-pill {
                    background: white;
                    border-radius: 20px;
                    padding: 10px 18px;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 0.85rem;
                    font-weight: 600;
                    color: #2c3e50;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                }

                .stat-icon {
                    font-size: 1.2rem;
                }

                /* Contact Visual (Category 4) */
                .contact-visual {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 25px;
                }

                .contact-simple-list {
                    display: flex;
                    flex-direction: column;
                    gap: 30px;
                    padding: 20px;
                }

                .contact-link {
                    text-decoration: none;
                    color: inherit;
                    display: block;
                }

                .contact-simple-item {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    padding: 25px 30px;
                    background: white;
                    border-radius: 16px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    cursor: pointer;
                }

                .contact-link:hover .contact-simple-item {
                    transform: translateX(8px);
                    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
                }

                .contact-icon {
                    font-size: 2rem;
                    min-width: 50px;
                    max-width: 30px;
                    height: auto;
                    text-align: center;
                }

                .contact-label {
                    font-size: 1rem;
                    font-weight: 700;
                    color: #2c5282;
                    min-width: 100px;
                }

                .contact-value {
                    font-size: 1rem;
                    color: #4a4a4a;
                    font-weight: 500;
                }

                @media (max-width: 1200px) {
                    .category-container {
                        padding: 80px 40px;
                    }

                    .category-content {
                        gap: 60px;
                    }

                    .category-title {
                        font-size: 2.5rem;
                    }

                    .description-paragraph {
                        font-size: 1.05rem;
                    }
                }

                @media (max-width: 968px) {
                    .category-container {
                        padding: 70px 30px;
                        min-height: auto;
                    }

                    .category-content {
                        grid-template-columns: 1fr;
                        gap: 50px;
                    }

                    .category-title {
                        font-size: 2.2rem;
                    }

                    .visual-container {
                        min-height: 400px;
                    }
                }

                @media (max-width: 768px) {
                    /* Premium Jobs - 2열 그리드로 변경 */
                    .job-cards-preview {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 10px;
                    }

                    .preview-card {
                        padding: 12px;
                    }

                    .company-badge {
                        font-size: 0.7rem;
                        padding: 3px 8px;
                    }

                    .status-badge {
                        font-size: 0.65rem;
                        padding: 2px 6px;
                    }

                    .card-title-mini {
                        font-size: 0.85rem;
                    }

                    .card-location {
                        font-size: 0.75rem;
                    }

                    .stat-pill {
                        padding: 8px 14px;
                        font-size: 0.8rem;
                    }

                    /* Service - 프로세스 플로우 조정 */
                    .process-flow {
                        padding: 20px 15px;
                    }

                    .step-number {
                        width: 35px;
                        height: 35px;
                        font-size: 1rem;
                    }

                    .step-icon {
                        font-size: 1.6rem;
                    }

                    .step-name {
                        font-size: 0.85rem;
                    }

                    .flow-arrow {
                        font-size: 1.2rem;
                        margin: 0 5px;
                    }

                    .badge-item {
                        padding: 8px 16px;
                        font-size: 0.85rem;
                    }

                    /* Contact - 간단 리스트 조정 */
                    .contact-simple-list {
                        gap: 20px;
                        padding: 15px;
                    }

                    .contact-simple-item {
                        padding: 20px 25px;
                        gap: 15px;
                    }

                    .contact-icon {
                        font-size: 1.6rem;
                        min-width: 40px;
                    }

                    .contact-label {
                        font-size: 0.9rem;
                        min-width: 80px;
                    }

                    .contact-value {
                        font-size: 0.9rem;
                    }
                }

                @media (max-width: 640px) {
                    .category-container {
                        padding: 60px 20px;
                    }

                    .category-kicker {
                        font-size: 0.85rem;
                        letter-spacing: 2px;
                    }

                    .category-title {
                        font-size: 1.8rem;
                    }

                    .description-paragraph {
                        font-size: 1rem;
                    }

                    .category-button {
                        width: 100%;
                        text-align: center;
                        padding: 16px 30px;
                        font-size: 1rem;
                    }

                    .visual-container {
                        padding: 35px 25px;
                        min-height: 350px;
                    }

                    .visual-text-box {
                        padding: 24px 28px;
                    }

                    .visual-line {
                        font-size: 0.95rem;
                    }

                    .visual-highlight {
                        font-size: 1.05rem;
                    }

                    .illustration-circle {
                        width: 160px;
                        height: 160px;
                    }

                    .rb-logo {
                        font-size: 2.5rem;
                    }

                    .person-icon {
                        font-size: 1.5rem;
                        width: 38px;
                        height: 38px;
                    }

                    /* Premium Jobs - 1열로 변경 */
                    .job-cards-preview {
                        grid-template-columns: 1fr;
                        gap: 12px;
                    }

                    .preview-card {
                        padding: 14px;
                    }

                    .card-header-mini {
                        flex-wrap: wrap;
                    }

                    /* Service - 세로 배치 */
                    .process-flow {
                        flex-direction: column;
                        gap: 15px;
                        padding: 25px 20px;
                    }

                    .flow-arrow {
                        transform: rotate(90deg);
                        margin: 0;
                    }

                    .service-badges {
                        gap: 8px;
                    }

                    .badge-item {
                        font-size: 0.8rem;
                        padding: 8px 14px;
                    }

                    /* Contact - 모바일 세로 정렬 */
                    .contact-simple-list {
                        gap: 15px;
                        padding: 10px;
                    }

                    .contact-simple-item {
                        flex-direction: column;
                        align-items: flex-start;
                        padding: 18px 20px;
                        gap: 10px;
                    }

                    .contact-icon {
                        font-size: 1.8rem;
                    }

                    .contact-label {
                        font-size: 0.85rem;
                        min-width: auto;
                    }

                    .contact-value {
                        font-size: 0.85rem;
                        word-break: break-word;
                    }

                    .contact-link:hover .contact-simple-item {
                        transform: none;
                    }

                    /* Stats 세로 배치 */
                    .jobs-stats {
                        flex-direction: column;
                        gap: 10px;
                    }

                    .stat-pill {
                        justify-content: center;
                    }
                }
            `}</style>
        </section>
    );
}
